import { h, Component } from 'preact';
import Router from 'preact-router';
import { observer } from 'mobx-preact';
import { createHashHistory } from 'history';

import util from '../../lib/util';

import Frontpage from '../frontpage';

import Dealers from '../dealers';
import DealersEdit from '../dealers/edit';

import Brands from '../brands';
import BrandsEdit from '../brands/edit';

import Categories from '../categories';
import CategoryEdit from '../categories/edit';

import Products from '../products';
import ProductEdit from '../products/edit';

import ProductCombos from '../productcombos';
import ProductCombosEdit from '../productcombos/edit';

import Tags from '../tags';
import TagsEdit from '../tags/edit';

import Articles from '../articles';
import ArticlesEdit from '../articles/edit';

import Consumers from '../consumers';
import ConsumersEdit from '../consumers/edit';

import RodRegs from '../rodregs';
import RodRegsEdit from '../rodregs/edit';

import Shipments from '../shipments';
import ShipmentsEdit from '../shipments/edit';

import Maillogs from '../maillogs';
import MaillogsEdit from '../maillogs/edit';

import MailAddresses from '../mailaddresses';
import MailAddressesEdit from '../mailaddresses/edit';

import Urls from '../urls';
import UrlsEdit from '../urls/edit';

// Content stores with observable values and attributes.
import appState from '../../stores/appstate';
import dealerStore from '../../stores/dealer';
import brandStore from '../../stores/brand';
import categoryStore from '../../stores/category';
import articleStore from '../../stores/article';
import productStore from '../../stores/product';
import productComboStore from '../../stores/productcombo';
import tagStore from '../../stores/tag';
import maillogStore from '../../stores/maillog';
import mailaddressStore from '../../stores/mailaddress';
import urlStore from '../../stores/url';
import consumerStore from '../../stores/consumer';
import rodregStore from '../../stores/rodreg';
import shipmentStore from '../../stores/shipment';

/*
    If this is a widget on a page with more widgets you should probably set this
    to false to prevent confusion.
*/
const USE_ROUTER = true;

const STATE = {
    CURRENT_NAV: 'currentNav',
};

@observer
class Main extends Component {
    constructor(props) {
        super(props);
        this.stores = {
            appState,
            dealerStore,
            brandStore,
            categoryStore,
            articleStore,
            productStore,
            productComboStore,
            tagStore,
            maillogStore,
            mailaddressStore,
            urlStore,
            consumerStore,
            rodregStore,
            shipmentStore,
        };

        dealerStore.loadRealdealer();

        const { darkmode } = appState;
        util.toggleDarkModeClasses(darkmode);
    }

    handleRoute = (event) => {
        const currentNav = event.url.replace(/^\/([^/?]+).*/g, '$1');
        this.setState({
            [STATE.CURRENT_NAV]: currentNav,
        });
        if (decodeURIComponent(event.url) !== decodeURIComponent(event.previous)) {
            // console.log(`${decodeURIComponent(event.url)} !== ${decodeURIComponent(event.previous)}`);
            if (event.current.attributes.categoryid) {
                categoryStore.load(event.current.attributes.categoryid);
            }
            if (event.current.attributes.customerno) {
                dealerStore.load(event.current.attributes.customerno);
            }
        }
    };

    getMainContent() {
        if (USE_ROUTER) {
            return (<Router onChange={this.handleRoute} history={createHashHistory()}>
                {/*
                    This would be a nice place for/more new routes.
                    <TagList path='/tag' />
                    <TagEdit path='/tag/:tagId' />
                */}
                <Dealers stores={this.stores} path='/dealers' {...this.props} />
                <DealersEdit stores={this.stores} path='/dealers/:customerno' {...this.props} />
                <DealersEdit stores={this.stores} path='/dealers/:customerno/:tabname' {...this.props} />

                <Brands stores={this.stores} path='/brands' {...this.props} />
                <BrandsEdit stores={this.stores} path='/brands/:brandid' {...this.props} />
                <BrandsEdit stores={this.stores} path='/brands/:brandid/:tabname' {...this.props} />

                <Categories stores={this.stores} path='/categories' {...this.props} />
                <CategoryEdit stores={this.stores} path='/categories/:categoryid' {...this.props} />
                <CategoryEdit stores={this.stores} path='/categories/:categoryid/:tabname' {...this.props} />

                <Products stores={this.stores} path='/products' {...this.props} />
                <ProductEdit stores={this.stores} path='/products/:productid' {...this.props} />
                <ProductEdit stores={this.stores} path='/products/:productid/:tabname' {...this.props} />

                <ProductCombos stores={this.stores} path='/productcombos' {...this.props} />
                <ProductCombosEdit stores={this.stores} path='/productcombos/:id' {...this.props} />
                <ProductCombosEdit stores={this.stores} path='/productcombos/:id/:tabname' {...this.props} />

                <Tags stores={this.stores} path='/tags' {...this.props} />
                <TagsEdit stores={this.stores} path='/tags/:id' {...this.props} />
                <TagsEdit stores={this.stores} path='/tags/:id/:tabname' {...this.props} />

                <Articles stores={this.stores} path='/articles' {...this.props} />
                <ArticlesEdit stores={this.stores} path='/articles/:id' {...this.props} />
                <ArticlesEdit stores={this.stores} path='/articles/:id/:tabname' {...this.props} />

                <Consumers stores={this.stores} path='/consumers' {...this.props} />
                <ConsumersEdit stores={this.stores} path='/consumers/:id' {...this.props} />
                <ConsumersEdit stores={this.stores} path='/consumers/:id/:tabname' {...this.props} />

                <RodRegs stores={this.stores} path='/rodregs' {...this.props} />
                <RodRegsEdit stores={this.stores} path='/rodregs/:serial' {...this.props} />
                <RodRegsEdit stores={this.stores} path='/rodregs/:serial/:tabname' {...this.props} />

                <Shipments stores={this.stores} path='/shipments' {...this.props} />
                <ShipmentsEdit stores={this.stores} path='/shipments/:uniqueid' {...this.props} />
                <ShipmentsEdit stores={this.stores} path='/shipments/:uniqueid/:tabname' {...this.props} />

                <Maillogs stores={this.stores} path='/maillogs' {...this.props} />
                <MaillogsEdit stores={this.stores} path='/maillogs/:id' {...this.props} />
                <MaillogsEdit stores={this.stores} path='/maillogs/:id/:tabname' {...this.props} />

                <MailAddresses stores={this.stores} path='/mailaddresses' {...this.props} />
                <MailAddressesEdit stores={this.stores} path='/mailaddresses/:id' {...this.props} />
                <MailAddressesEdit stores={this.stores} path='/mailaddresses/:id/:tabname' {...this.props} />

                <Urls stores={this.stores} path='/urls' {...this.props} />
                <UrlsEdit stores={this.stores} path='/urls/:id' {...this.props} />
                <UrlsEdit stores={this.stores} path='/urls/:id/:tabname' {...this.props} />

                <Frontpage stores={this.stores} default {...this.props} />
            </Router>);
        }
        return (<Frontpage stores={this.stores} default {...this.props} />);
    }

    render() {
        return (
            <div class='container-fluid'>
                { this.getMainContent() }
            </div>
        );
    }
}

export default Main;



// WEBPACK FOOTER //
// ./components/main/index.js